var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: url(#Gradiente_sem_nome_19);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_19",
    "data-name": "Gradiente sem nome 19",
    x1: 32,
    y1: 256,
    x2: 480,
    y2: 256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0072fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00a076"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M440,144h-8v-16c0-44.11-35.89-80-80-80h-192c-44.11,0-80,35.89-80,80v16h-8c-22.06,0-40,17.95-40,40v40c0,8.83,7.15,16,16,16s16-7.17,16-16v-40c0-4.42,3.6-8,8-8h8v160c0,26.05,12.7,49.01,32.03,63.62,0,.13-.03.26-.03.38v32c0,17.68,14.32,32,32,32h16c17.68,0,32-14.32,32-32v-16h128v16c0,17.68,14.32,32,32,32h16c17.68,0,32-14.32,32-32v-32c0-.13-.03-.26-.03-.38,19.33-14.62,32.03-37.57,32.03-63.62v-160h8c4.4,0,8,3.58,8,8v40c0,8.83,7.15,16,16,16s16-7.17,16-16v-40c0-22.05-17.94-40-40-40ZM152,368c-13.25,0-24-10.75-24-24s10.75-24,24-24,24,10.75,24,24-10.75,24-24,24ZM360,368c-13.25,0-24-10.75-24-24s10.75-24,24-24,24,10.75,24,24-10.75,24-24,24ZM400,231.6c0,15.63-11.25,29.25-26.7,31.58-37.98,5.71-77.17,8.78-117.3,8.78s-79.31-3.06-117.3-8.78c-15.46-2.34-26.7-15.95-26.7-31.58v-87.6c0-17.68,14.32-32,32-32h224c17.68,0,32,14.32,32,32v87.6Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBus);
export default __webpack_public_path__ + "static/media/bus.d8cef532c8672f2acbad8969e9118d1f.svg";
export { ForwardRef as ReactComponent };